import TurnedParts from './turnedParts';
export default TurnedParts;
